import type { FragmentImage } from '@fast-editor/core'
import { RunImage } from '@fast-editor/core'
import type { WebCanvasContext } from 'src/WebCanvasContext'

export class RunImageWeb extends RunImage {
  public img: HTMLImageElement
  public append = false
  public loaded = false
  public fail = false
  public inBuffer = false
  public inViewport = false

  constructor(frag: FragmentImage) {
    super(frag)
    this.img = new Image()
    this.img.style.display = 'none'
    this.img.style.position = 'absolute'
    this.img.style.width = `${this.frag.attributes.width}px`
    this.img.style.height = `${this.frag.attributes.height}px`
  }

  public override destroy(): void {
    this.img.onload = null
    this.img.onerror = null
    this.img.src = ''
    this.img.remove()
  }

  public override enterBuffer() {
    this.inBuffer = true
    // if the image has not loaded yet, we need to load it
    if (!this.img.src) {
      this.loadImage()
    }
  }

  public override leaveBuffer() {
    this.inBuffer = false
  }

  public override enterViewport() {
    this.inViewport = true
    this.img.style.display = 'block'
  }

  public override leaveViewport() {
    this.img.style.display = 'none'
    this.inViewport = false
  }

  /**
   * 绘制当前图片
   */
  public override draw(ctx: WebCanvasContext, x: number, y: number): void {
    if (!this.inBuffer) {
      this.enterBuffer()
    }
    if (!this.inViewport) {
      this.enterViewport()
    }
    if (!this.append) {
      ctx.getDomElementContainer().append(this.img)
      this.append = true
    }
    this.img.style.left = `${this.x + x}px`
    this.img.style.top = `${this.y + y}px`
  }

  /**
   * 加载 image，尝试 3 次都不成功就放弃了
   */
  public loadImage(times = 0) {
    this.img.src = ''
    this.img.onload = () => {
      this.loaded = true
    }
    this.img.onerror = () => {
      if (times < 2) {
        this.loadImage(times + 1)
      } else {
        this.fail = true
      }
    }
    this.img.src = this.frag.attributes.src
  }
}
